/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * My Emissions API
 * We calculate food carbon footprints
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `local` - Local
* `regional` - Regional
* `national` - National
 */
export type SuppliersProximityEnum = typeof SuppliersProximityEnum[keyof typeof SuppliersProximityEnum];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SuppliersProximityEnum = {
  local: 'local',
  regional: 'regional',
  national: 'national',
} as const;
